import { ValueOf } from '@shared/types/common.ts';
import { UserCountryCode, UserCountryCodes } from '@shared/types/countryCodes.ts';

export const defaultChartColorPalette = ['#3B82F6', '#A855F7', '#22C55E'] as const;
export const germanyChartColorPalette = ['#00BE98', '#951E3D', '#380011'] as const;

export type ChartColorPalette = typeof defaultChartColorPalette | typeof germanyChartColorPalette;

export const ChartColorRoles = {
  CTV: 'ctv',
  DIGITAL: 'digital',
  LINEAR: 'linear',
} as const;

export type ChartColorRole = ValueOf<typeof ChartColorRoles>;

const chartColorRoleIndex: Record<ChartColorRole, 0 | 1 | 2> = {
  [ChartColorRoles.CTV]: 0,
  [ChartColorRoles.DIGITAL]: 1,
  [ChartColorRoles.LINEAR]: 2,
};

export function getChartColorPaletteByCountry(countryCode: UserCountryCode | null): ChartColorPalette {
  switch (countryCode) {
    case UserCountryCodes.DE: {
      return germanyChartColorPalette;
    }
    default: {
      return defaultChartColorPalette;
    }
  }
}

export function getChartColorByRole(countryCode: UserCountryCode | null, role: ChartColorRole): string {
  const palette = getChartColorPaletteByCountry(countryCode);

  return palette[chartColorRoleIndex[role]];
}
